import axiosClient from "../../../../system/helpers/axiosConfig";

export const API_KEY_GET_ADMIN_TOP_STATS = "API_KEY_GET_ADMIN_TOP_STATS";
export const getTopStats = () => {
  return axiosClient.get("/api/admin/dashboard/top-stats").then((r) => r.data);
};
